import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Container, Button, Form } from "react-bootstrap";
import moment from "moment";
import { useQuery } from "@tanstack/react-query";
import CustomModal from "../../components/UiComponent/Modal";
import SalaryPreview from "./salaryPreview";
import usePayrollApi from "../../services/payroll/payrollApi";
import { toast } from "react-toastify";
const CreatePayrollSheet = () => {
  const { t } = useTranslation();
  const { get_payroll_employee_list } = usePayrollApi();
  const [showModal, setShowModal] = useState(false);
  const [rowData, setRowData] = useState([]);
  const currentDate = new Date();
  const formattedDate = moment(currentDate).format("YYYY-MM-DD");
  const [selectedDate, setSelectedDate] = useState(formattedDate);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const getPayrollQuery = useQuery(["Payroll_employee_list"], () =>
    get_payroll_employee_list()
  );
  const payrollData = useMemo(() => {
    return getPayrollQuery.data?.data?.emp_list || [];
  }, [getPayrollQuery.data]);

  useEffect(() => {
    if (payrollData.length > 0) {
      setRowData(
        payrollData.map((row) => ({ ...row, penality: 0, reason: "" }))
      );
    }
  }, [payrollData]);

  if (getPayrollQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (getPayrollQuery.isError) {
    return <div>Error: {getPayrollQuery.error.message}</div>;
  }
  const handleInputChange = (e, rowIndex, columnName) => {
    const { value } = e.target;
    if (value >= 0) {
      const updatedData = [...rowData];
      updatedData[rowIndex][columnName] = value;
      setRowData(updatedData);
    }
  };
  const previewPayroll = (e) => {
    e.preventDefault();
    const selectedData = selectedRows.map((index) => rowData[index]);
    if (selectedRows.length === 0) {
      toast.error("Please select at least one employee to preview", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return 0;
    }
    setSelectedEmployee(selectedData);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleHeaderCheckboxChange = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    const newSelectedRows = checked ? rowData.map((row, index) => index) : [];
    setSelectedRows(newSelectedRows);
  };

  const handleRowCheckboxChange = (index) => {
    const selectedIndex = selectedRows.indexOf(index);
    let newSelectedRows = [...selectedRows];

    if (selectedIndex === -1) {
      newSelectedRows = [...newSelectedRows, index];
    } else {
      newSelectedRows.splice(selectedIndex, 1);
    }

    setSelectedRows(newSelectedRows);
    setSelectAll(newSelectedRows.length === rowData.length);
  };
  return (
    <Container fluid>
      <div className="d-flex flex-wrap align-items-center justify-content-between my-4">
        <div className="d-flex align-items-center justify-content-sm-between">
          <h5 className="font-weight-bold mr-3">
            Prepare monthly payroll for{" "}
            {moment(selectedDate).format("MMM YYYY")}{" "}
          </h5>
        </div>

        <div className="create-workform">
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            <div className="modal-product-search d-flex align-items-center">
              <div className=" position-relative d-flex align-items-center justify-content-between">
                <Button
                  variant="btn btn-info btn-sm m-2"
                  onClick={(event) => previewPayroll(event)}
                >
                  {t("preview_payroll")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <table className="table table-bordered table-responsive-md table-striped text-center">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                onChange={handleHeaderCheckboxChange}
                checked={selectAll}
              />
            </th>
            <th>{t("full_name")}</th>
            <th>{t("gross")}</th>
            <th>{t("benefit")}</th>
            <th>{t("benefit")}%</th>
            <th>{t("deduction")}</th>
            <th>{t("deduction")}%</th>
            <th>{t("penality")}</th>
            <th>{t("reason")}</th>
          </tr>
        </thead>
        <tbody>
          {rowData.map((row, index) => (
            <tr key={row.id}>
              <td>
                <input
                  type="checkbox"
                  onChange={() => handleRowCheckboxChange(index)}
                  checked={selectedRows.includes(index)}
                />
              </td>
              <td>
                {row.first_name} {row.father_name}
              </td>
              <td>{row.employee_details[0]?.salary}</td>
              <td>{row.total_benefit_fixed_amount}</td>
              <td>{row.total_benefit_percentage}</td>
              <td>{row.total_deductions_fixed_amount}</td>
              <td>{row.total_deductions_percentage}</td>
              <td>
                <Form.Control
                  type="number"
                  min="0"
                  aria-label="Small"
                  value={row.penality}
                  onChange={(e) => handleInputChange(e, index, "penality")}
                  aria-describedby="inputGroup-sizing-sm"
                  style={{ border: "1px solid #ced4da", width: "100px" }}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  aria-label="Small"
                  value={row.reason}
                  onChange={(e) => handleInputChange(e, index, "reason")}
                  aria-describedby="inputGroup-sizing-sm"
                  style={{ border: "1px solid #ced4da" }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex flex-wrap align-items-center justify-content-between">
        <Button
          variant="btn btn-info btn-sm m-2"
          onClick={(event) => previewPayroll(event)}
        >
          {t("preview_payroll")}
        </Button>
      </div>

      <CustomModal
        show={showModal}
        title="Employee Salary Information"
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        size="xl"
        content={
          <SalaryPreview
            closeModal={handleCloseModal}
            employeeData={selectedEmployee}
          />
        }
      />
    </Container>
  );
};

export default CreatePayrollSheet;
